// extracted by mini-css-extract-plugin
export default {"title":"ErrorMessage_title__rgKLY","error":"ErrorMessage_error__pZjp6"};